import React from "react";
import { LFormInput } from "@loffa/gpp-modules";

interface LRequiredInputProps {
  labelName: string;
  required: boolean;
  [key: string]: any;
}
//used in conjunction with <LFormInput/> - adds a red * to the input label
function LRequiredInput({ labelName, required, ...rest }: LRequiredInputProps) {
  const modifiedLabel = required ? (
    <>
      {labelName} <span style={{ color: "red" }}>*</span>
    </>
  ) : (
    labelName
  );

  return <LFormInput labelName={modifiedLabel} required={required} {...rest} />;
}
export { LRequiredInput };
